export default __webpack_public_path__ + "static/media/asset 26.c5a67c33.png";